export default __webpack_public_path__ + "static/avatar-kayi-common-5-cover-231f39a0b3d86ef18230769394151aa7.png";